import { useState } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset, kuiperClassNames, TextArea } from '@opallabs/kuiper'
import {
  Module,
  OnDragDropProps,
  OnShowAssetPickerProps,
} from '@opallabs/periodic/src/Content/helpers/types'
import { SingleAssetPicker } from '@opallabs/periodic/src/SingleAssetPicker'
import { Overlay } from './Overlay'
import { styles } from './styles'

export type DisplayProps = {
  accountImage: AssetReference | null
  accountName: string
  allowReplies: boolean
  allowSharing: boolean
  collabAccount: string
  cta: string
  ctaUrl: string
  instagramCollab: boolean
  isDragging: boolean
  isPresenting: boolean
  content: string
  index: number
  modules: Module[]
  assets: AssetReference[]
  onDragDrop: OnDragDropProps
  onExpandAsset: (id: number) => void
  onRemoveAsset: (id: number, index: number) => void
  onShowAssetPicker: (args: OnShowAssetPickerProps) => void
  postType: string
  readOnly: boolean
  updateText: (val: string, dest: string) => void
}

export const StoryMobileSingle: React.FC<DisplayProps> = ({
  accountImage,
  accountName,
  allowReplies,
  allowSharing,
  isDragging,
  isPresenting,
  collabAccount,
  content,
  cta,
  ctaUrl,
  index,
  instagramCollab,
  modules,
  assets,
  onDragDrop,
  onExpandAsset,
  onRemoveAsset,
  onShowAssetPicker,
  postType,
  readOnly,
  updateText,
}) => {
  const asset = assets && assets.length ? assets[0] : null
  const [isHovering, setIsHovering] = useState(false)
  let maxSections = 1000
  if (postType === 'native_story_link_ad') maxSections = 4
  else if (postType === 'expandable_story_link_ad') maxSections = 11

  return (
    <div
      className={kuiperClassNames('mobileSingle-story')}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {asset && (
        <Overlay
          accountImage={accountImage}
          accountName={accountName}
          allowReplies={allowReplies}
          allowSharing={allowSharing}
          collabAccount={collabAccount}
          currentIndex={index}
          cta={cta}
          ctaUrl={ctaUrl}
          instagramCollab={instagramCollab}
          modulesLength={modules.length || 0}
          postType={postType}
        />
      )}
      <div css={styles.assetWrapper}>
        {asset ? (
          <div css={styles.assetStyle}>
            <Asset
              imageFit="cover"
              assetReference={asset}
              placeholder={false}
              isHovered={isHovering}
              hasAssetOverlay={asset && (!readOnly || isPresenting)}
              removeable={!readOnly}
              overrideStyles={{
                assetBase: styles.getAssetBaseStyle(asset.asset_type || ''),
                asset: styles.getAssetBaseStyle(asset.asset_type || ''),
              }}
              onEmbiggen={() => onExpandAsset(asset.id || 0)}
              onRemove={() => onRemoveAsset(asset.id || 0, index)}
            />
          </div>
        ) : (
          <SingleAssetPicker
            allowedUploadTypes={maxSections - modules.length || 1}
            disableDrop={isDragging}
            onDragDrop={(e) =>
              onDragDrop(e, {
                destination: 'carousel',
                index,
                allowMultiple: maxSections - modules.length || 1,
              })
            }
            onShowAssetPicker={() =>
              onShowAssetPicker({
                destination: 'carousel',
                index,
                allowMultiple: maxSections - modules.length || 1,
              })
            }
            readOnly={readOnly}
            style={{ height: 667, width: 375 }}
          />
        )}
        {!(readOnly && !content) && postType !== 'native_story_link_ad' && (
          <div
            className={kuiperClassNames('asset-carousel-content-textarea')}
            css={styles.contentWrapperStyle}
          >
            <TextArea
              minRows={1}
              placeholder={'Add content...'}
              value={content || ''}
              style={styles.contentStyle}
              readOnly={readOnly}
              onChange={(val: string) => updateText(val, 'content')}
            />
          </div>
        )}
      </div>
    </div>
  )
}
